/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductTile_user = {
    readonly serviceId: string | null;
    readonly " $refType": "StorefrontProductTile_user";
};
export type StorefrontProductTile_user$data = StorefrontProductTile_user;
export type StorefrontProductTile_user$key = {
    readonly " $data"?: StorefrontProductTile_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontProductTile_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '32609aab90ed10c6bdcfe0b4525e0027';
export default node;
